// /* global Word */

// async function findAllBracketFields(context) {
//   const results = context.document.body.search("\\[*\\]", {
//     matchWildcards: true
//   });
//   context.load(results, "items");
//   await context.sync();
//   return results.items;
// }

// async function goToNextField() {
//   await Word.run(async (context) => {
//     const fields = await findAllBracketFields(context);
//     if (!fields.length) return;

//     const selection = context.document.getSelection();
//     selection.load("text");
//     await context.sync();

//     // Get current cursor position
//     const cursorStart = selection.getRange("Start");
    
//     // Phase 1: issue comparisons
//     const comparisons = fields.map(f => ({
//       field: f,
//       result: cursorStart.compareLocationWith(f)
//     }));

//     // Phase 2: sync to populate .value
//     await context.sync();

//     // Phase 3: find the next field after cursor
//     let target = null;
//     for (let i = 0; i < comparisons.length; i++) {
//       // LocationRelation: Before = 0, Start = 1, Inside = 2, End = 3, After = 4
//       // We want the first field that starts after our cursor
//       if (comparisons[i].result.value === Word.LocationRelation.before ||
//           comparisons[i].result.value === Word.LocationRelation.start) {
//         target = comparisons[i].field;
//         break;
//       }
//     }

//     // If no field found ahead, wrap to first field
//     if (!target) {
//       target = fields[0];
//     }

//     // Position cursor inside the brackets (after the '[')
//     target.load("text");
//     await context.sync();
    
//     // Get the start position, then insert a character and delete it
//     // This moves us one position forward
//     const startPos = target.getRange("Start");
//     const tempRange = startPos.insertText("X", "After");
//     tempRange.delete();
//     await context.sync();
    
//     // Now select at this position
//     const insideRange = target.getRange("Start");
//     insideRange.select();
//     await context.sync();
//   });
// }

// async function goToPreviousField() {
//   await Word.run(async (context) => {
//     const fields = await findAllBracketFields(context);
//     if (!fields.length) return;

//     const selection = context.document.getSelection();
//     selection.load("text");
//     await context.sync();

//     // Get current cursor position
//     const cursorStart = selection.getRange("Start");
    
//     // Phase 1: issue compare calls
//     const comparisons = fields.map(f => ({
//       field: f,
//       result: cursorStart.compareLocationWith(f)
//     }));

//     // Phase 2: sync to populate .value
//     await context.sync();

//     // Phase 3: find the previous field before cursor
//     let target = null;
//     for (let i = comparisons.length - 1; i >= 0; i--) {
//       // We want the last field that ends before our cursor
//       if (comparisons[i].result.value === Word.LocationRelation.after ||
//           comparisons[i].result.value === Word.LocationRelation.end) {
//         target = comparisons[i].field;
//         break;
//       }
//     }

//     // If no field found before, wrap to last field
//     if (!target) {
//       target = fields[fields.length - 1];
//     }

//     // Position cursor inside the brackets (after the '[')
//     target.load("text");
//     await context.sync();
    
//     // Get the start position, then insert a character and delete it
//     // This moves us one position forward
//     const startPos = target.getRange("Start");
//     const tempRange = startPos.insertText("X", "After");
//     tempRange.delete();
//     await context.sync();
    
//     // Now select at this position
//     const insideRange = target.getRange("Start");
//     insideRange.select();
//     await context.sync();
//   });
// }

// export { goToNextField, goToPreviousField };



/* global Word */

async function findAllBracketFields(context) {
  const results = context.document.body.search("\\[*\\]", {
    matchWildcards: true
  });
  context.load(results, "items");
  await context.sync();
  return results.items;
}

async function clearAllHighlights(context) {
  const fields = await findAllBracketFields(context);
  
  // Clear highlight from all fields
  for (const field of fields) {
    field.font.highlightColor = null; // Remove highlight
  }
  
  await context.sync();
}

async function selectFieldContent(context, target) {
  // Load the target field's text
  target.load("text");
  await context.sync();

  const fieldText = target.text;
  const innerText = fieldText.slice(1, -1); // Content between '[' and ']'

  // Highlight the current active bracket in green
  target.font.highlightColor = "Grey"; // Light green
  await context.sync();

  if (innerText.trim().length > 0) {
    // There is text inside - select ONLY the inner text for replacement
    // Search for the exact inner text within the field
    const innerSearch = target.search(innerText, {
      matchCase: true,
      matchWholeWord: false
    });
    innerSearch.load("items");
    await context.sync();
    
    if (innerSearch.items.length > 0) {
      // Select the first match (the text inside brackets)
      innerSearch.items[0].select("Select");
      await context.sync();
    } else {
      // Fallback: manually create range for inner text
      const startRange = target.getRange("Start");
      startRange.load();
      await context.sync();
      
      // Create a range starting 1 char after '[' with length of inner text
      const textRange = startRange.insertText("", "After");
      textRange.moveStart("Character", 1);
      textRange.moveEnd("Character", innerText.length);
      textRange.select("Select");
      await context.sync();
    }
  } else {
    // No text inside - position cursor at start+1 (after '[')
    const startRange = target.getRange("Start");
    startRange.load();
    await context.sync();
    
    // Position cursor right after '['
    const cursorPos = startRange.insertText("", "After");
    cursorPos.select("Select");
    await context.sync();
    
    // Move right by 1 character
    const sel = context.document.getSelection();
    sel.move("Character", 1);
    await context.sync();
  }
}

async function goToNextField() {
  await Word.run(async (context) => {
    const fields = await findAllBracketFields(context);
    if (!fields.length) return;

    const selection = context.document.getSelection();
    selection.load("text");
    await context.sync();

    // Get current cursor position
    const cursorStart = selection.getRange("Start");
    
    // Phase 1: issue comparisons
    const comparisons = fields.map(f => ({
      field: f,
      result: cursorStart.compareLocationWith(f)
    }));

    // Phase 2: sync to populate .value
    await context.sync();

    // Phase 3: find the next field after cursor
    let target = null;
    for (let i = 0; i < comparisons.length; i++) {
      if (comparisons[i].result.value === Word.LocationRelation.before ||
          comparisons[i].result.value === Word.LocationRelation.start) {
        target = comparisons[i].field;
        break;
      }
    }

    // If no field found ahead, wrap to first field
    if (!target) {
      target = fields[0];
    }

    // Clear all previous highlights first
    await clearAllHighlights(context);

    // Select the field content
    await selectFieldContent(context, target);
  });
}

async function goToPreviousField() {
  await Word.run(async (context) => {
    const fields = await findAllBracketFields(context);
    if (!fields.length) return;

    const selection = context.document.getSelection();
    selection.load("text");
    await context.sync();

    // Get current cursor position
    const cursorStart = selection.getRange("Start");
    
    // Phase 1: issue compare calls
    const comparisons = fields.map(f => ({
      field: f,
      result: cursorStart.compareLocationWith(f)
    }));

    // Phase 2: sync to populate .value
    await context.sync();

    // Phase 3: find the previous field before cursor
    let target = null;
    for (let i = comparisons.length - 1; i >= 0; i--) {
      if (comparisons[i].result.value === Word.LocationRelation.after ||
          comparisons[i].result.value === Word.LocationRelation.end) {
        target = comparisons[i].field;
        break;
      }
    }

    // If no field found before, wrap to last field
    if (!target) {
      target = fields[fields.length - 1];
    }

    // Clear all previous highlights first
    await clearAllHighlights(context);

    // Select the field content
    await selectFieldContent(context, target);
  });
}

export { goToNextField, goToPreviousField };

















// /* global Word */

// async function findAllBracketFields(context) {
//   const results = context.document.body.search("\\[*\\]", {
//     matchWildcards: true
//   });
//   context.load(results, "items");
//   await context.sync();
//   return results.items;
// }

// async function clearAllHighlights(context) {
//   const fields = await findAllBracketFields(context);

//   // Clear highlight from all fields
//   for (const field of fields) {
//     field.font.highlightColor = null;
//   }

//   await context.sync();
// }

// async function selectFieldContent(context, target) {
//   // Load the target field's text
//   target.load("text");
//   await context.sync();

//   const fieldText = target.text;
//   // const innerText = fieldText.slice(1, -1); // Content between '[' and ']'

//   const innerText = fieldText;

//   // Highlight the current active bracket in grey
//   target.font.highlightColor = "Grey";
//   await context.sync();

//   if (innerText.trim().length > 0) {
//     // There is text inside - select ONLY the inner text for replacement
//     const innerSearch = target.search(innerText, {
//       matchCase: true,
//       matchWholeWord: false
//     });
//     innerSearch.load("items");
//     await context.sync();

//     if (innerSearch.items.length > 0) {
//       // Select the first match (the text inside brackets)
//       innerSearch.items[0].select("Select");
//       await context.sync();
//     } else {
//       // Fallback: select entire field
//       target.select("Select");
//       await context.sync();
//     }
//   } else {
//     // No text inside - select the entire empty field
//     // This ensures the field is selected for capture
//     target.select("Select");
//     await context.sync();
//   }
// }

// /**
//  * Navigate to the next field and capture its state for surgical updates
//  */
// async function goToNextField() {
//   await Word.run(async (context) => {
//     const fields = await findAllBracketFields(context);
//     if (!fields.length) {
//       console.log("No fields found");
//       return;
//     }

//     const selection = context.document.getSelection();
//     selection.load("text");
//     await context.sync();

//     // Get current cursor position
//     const cursorStart = selection.getRange("Start");

//     // Phase 1: issue comparisons
//     const comparisons = fields.map(f => ({
//       field: f,
//       result: cursorStart.compareLocationWith(f)
//     }));

//     // Phase 2: sync to populate .value
//     await context.sync();

//     // Phase 3: find the next field after cursor
//     let target = null;
//     for (let i = 0; i < comparisons.length; i++) {
//       if (comparisons[i].result.value === Word.LocationRelation.before ||
//         comparisons[i].result.value === Word.LocationRelation.start) {
//         target = comparisons[i].field;
//         break;
//       }
//     }

//     // If no field found ahead, wrap to first field
//     if (!target) {
//       target = fields[0];
//     }

//     // Clear all previous highlights
//     await clearAllHighlights(context);

//     // ★★★ CRITICAL: Select the field content INSIDE Word.run ★★★
//     await selectFieldContent(context, target);
    
//     console.log("✓ Navigated to next field");
//   });

//   // ★★★ CRITICAL: Capture field state AFTER Word.run completes ★★★
//   // The setTimeout ensures Word has fully completed the selection
//   setTimeout(async () => {
//     if (window.FieldStateManager) {
//       await window.FieldStateManager.captureFieldState();
//     } else {
//       console.warn("⚠ FieldStateManager not available");
//     }
//   }, 300);
// }

// /**
//  * Navigate to the previous field and capture its state for surgical updates
//  */
// async function goToPreviousField() {
//   await Word.run(async (context) => {
//     const fields = await findAllBracketFields(context);
//     if (!fields.length) {
//       console.log("No fields found");
//       return;
//     }

//     const selection = context.document.getSelection();
//     selection.load("text");
//     await context.sync();

//     // Get current cursor position
//     const cursorStart = selection.getRange("Start");

//     // Phase 1: issue compare calls
//     const comparisons = fields.map(f => ({
//       field: f,
//       result: cursorStart.compareLocationWith(f)
//     }));

//     // Phase 2: sync to populate .value
//     await context.sync();

//     // Phase 3: find the previous field before cursor
//     let target = null;
//     for (let i = comparisons.length - 1; i >= 0; i--) {
//       if (comparisons[i].result.value === Word.LocationRelation.after ||
//         comparisons[i].result.value === Word.LocationRelation.end) {
//         target = comparisons[i].field;
//         break;
//       }
//     }

//     // If no field found before, wrap to last field
//     if (!target) {
//       target = fields[fields.length - 1];
//     }

//     // Clear all previous highlights
//     await clearAllHighlights(context);

//     // ★★★ CRITICAL: Select the field content INSIDE Word.run ★★★
//     await selectFieldContent(context, target);
    
//     console.log("✓ Navigated to previous field");
//   });

//   // ★★★ CRITICAL: Capture field state AFTER Word.run completes ★★★
//   setTimeout(async () => {
//     if (window.FieldStateManager) {
//       await window.FieldStateManager.captureFieldState();
//     } else {
//       console.warn("⚠ FieldStateManager not available");
//     }
//   }, 300);
// }

// export { goToNextField, goToPreviousField };

// ══════════════════════════════════════════════════════════════════════════════
// CRITICAL NOTES
// ══════════════════════════════════════════════════════════════════════════════
//
// 1. Field selection MUST happen INSIDE Word.run (before the context closes)
// 2. Field capture MUST happen AFTER Word.run completes (outside, with setTimeout)
// 3. The 150ms delay ensures Word has fully applied the selection
// 4. selectFieldContent() selects the ENTIRE field including brackets
//    so that FieldStateManager can capture it correctly
//
// Flow:
// -----
// User presses arrow → goToNextField() called
//   → Word.run starts
//   → Find target field
//   → Clear old highlights
//   → selectFieldContent(target) - selects entire field
//   → Word.run ends
//   → Wait 150ms
//   → FieldStateManager.captureFieldState() - captures selected text
//   → Field state stored in memory
//   → User dictates
//   → Transcription arrives
//   → Surgical update: diff → yellow → replace → green
//
// ══════════════════════════════════════════════════════════════════════════════